import React from "react";
import productShoes from "../../../assets/product-shoes.png";
import indiaFlag from "../../../assets/flag-india.png";

export default function ProductImageCard() {
  return (
    <>
      <div className="pic-card">
        <div className="pic-image-wrap">
          <img
            src={productShoes}
            alt="Chaussures de sécurité"
            className="pic-image"
          />
        </div>

        <div className="pic-image-footer">
          <span>KG 13 </span>
          <button>Éditer</button>
        </div>

        <div className="pic-details">
          <div className="pic-section">
            <h3>Nom commercial</h3>
            <div className="pic-line">
              <span className="pic-bullet">●</span>
              <span>Chaussures de sécurité Vikodeeen</span>
            </div>
          </div>

          <div className="pic-section">
            <h3>Catégorie / Famille :</h3>
            <div className="pic-line">
              <span className="pic-bullet">●</span>
              <span>Footwear / Chaussures</span>
            </div>
          </div>

          <div className="pic-section">
            <h3>Marque :</h3>
            <div className="pic-line">
              <span className="pic-bullet">●</span>
              <span>Yikodeen</span>
            </div>
          </div>

          <div className="pic-section">
            <h3>SKU / Reference produit :</h3>
            <div className="pic-line">
              <span className="pic-bullet">●</span>
              <span>YD-KS15</span>
            </div>
          </div>

          <div className="pic-section">
            <h3 className="pic-inline-title">
              Pays d'origine : Inde
              <img src={indiaFlag} alt="Inde" className="pic-flag-img" />
            </h3>
          </div>

          <div className="pic-section pic-last-section">
            <h3>Type Route : Route B</h3>
            <p>
              Chaussures de securité en cuir dotées d'un embout en acier et de
              semelles antidérapantes.
            </p>
          </div>
        </div>

        <div className="pic-bottom-edit">
          <button>Éditer</button>
        </div>
      </div>

      <style>{`
        .pic-card {
          border-radius: 16px;
          overflow: hidden;
          background: linear-gradient(180deg, rgba(28,38,73,0.96), rgba(20,28,55,0.96));
          border: 1px solid rgba(255,255,255,0.07);
          box-shadow: 0 14px 32px rgba(0,0,0,0.24);
        }

        .pic-image-wrap {
          background: #f4f4f6;
          padding: 10px 12px;
          height: 205px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .pic-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }

        .pic-image-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 12px;
          border-top: 1px solid rgba(255,255,255,0.06);
          border-bottom: 1px solid rgba(255,255,255,0.06);
          color: #b0bddf;
          font-size: 11px;
          min-height: 42px;
        }

        .pic-image-footer button,
        .pic-bottom-edit button {
          height: 32px;
          padding: 0 16px;
          border-radius: 8px;
          border: 1px solid rgba(255,255,255,0.08);
          background: rgba(255,255,255,0.05);
          color: #edf3ff;
          font-size: 14px;
          cursor: pointer;
        }

        .pic-details {
          padding: 12px 16px 8px;
        }

        .pic-section {
          padding: 10px 0;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }

        .pic-last-section {
          border-bottom: none;
          padding-bottom: 6px;
        }

        .pic-section h3 {
          margin: 0 0 8px;
          color: #f2f6ff;
          font-size: 17px;
          font-weight: 700;
          line-height: 1.35;
        }

        .pic-inline-title {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .pic-line,
        .pic-section p {
          color: #d9e2ff;
          font-size: 15px;
          line-height: 1.45;
          margin: 0;
        }

        .pic-line {
          display: flex;
          align-items: center;
          gap: 0;
        }

        .pic-bullet {
          color: #5fa58a !important;
          display: inline-block;
          margin-right: 8px;
          font-size: 16px;
          line-height: 1;
          flex-shrink: 0;
        }

        .pic-flag-img {
          width: 22px;
          height: 15px;
          object-fit: cover;
          border-radius: 2px;
          display: inline-block;
          box-shadow: 0 0 0 1px rgba(255,255,255,0.08);
        }

        .pic-bottom-edit {
          padding: 0 16px 14px;
          display: flex;
          justify-content: flex-end;
        }

        @media (max-width: 760px) {
          .pic-image-wrap {
            height: 180px;
          }

          .pic-section h3 {
            font-size: 16px;
          }

          .pic-line,
          .pic-section p {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
}